<script setup lang="ts">
import { computed } from 'vue'
const props = defineProps<{ state?: string }>()
const label = computed(() => ({ local: '本地待同步', syncing: '同步中', synced: '已同步', failed: '失败', conflict: '有冲突' }[props.state ?? ''] ?? ''))
</script>
<template><span v-if="label" class="sync-badge" :data-state="state">{{ label }}</span></template>
